const jobCard = {
  Days: {
    MO: 'Monday',
    TU: 'Tuesday',
    WE: 'Wednesday',
    TH: 'Thursday',
    FR: 'Friday',
    SA: 'Saturday',
    SU: 'Sunday',
  },
  LiveIn: 'Live-in',
  ScheduleLabel: '#{day} | #{timeRange}',
  LocationFormat: '#{neighborhood}, #{city}',
  Location: '#{neighborhood}, #{city} - #{clientName}',
  ClientUnknown: 'Unknown Client',
  WeeklyPay: '$#{amount}/week',
  JobDetails: 'Rate: $#{amount}/week • $#{rate}/hr • #{hours} hrs/week • #{count} shifts',
  BoxDetails: 'View Details',
  Deactivate: 'Deactivate',
  Reactivate: 'Reactivate',
  Internal: '#{count} Internal',
  External: '#{count} External',
};

export default jobCard;
